import store from '../store/index';
import { TABLE_NUM_ITEMS } from '../constants';

const cancellationReasonsGuard = (to, from, next) => {
    store.dispatch('users/LoadAllCancellationReasons', { offset: 0, limit: TABLE_NUM_ITEMS}).then(() => next());
}

export default cancellationReasonsGuard;
